class CoreHeaderNavController {
    constructor(shopperService, analyticsService, settingsService, $rootScope, $location) {
        this.shopperService = shopperService;
        this.analyticsService = analyticsService;
        this.settings = settingsService.settings;
        this.isReorder = false;
        this.isMyList = false;

        //  As part of quick reorder experiment
        $rootScope.$on('$locationChangeStart', (event, next) => {
            this.updateReorderStatus(next);
        });

        this.updateReorderStatus($location.path());
        //  As part of quick reorder experiment end

    }

    //  As part of quick reorder experiment
    updateReorderStatus(currentUrl) {
        this.isReorder = currentUrl.indexOf('/mylists/reorder') >= 0;
        this.isMyList = currentUrl.indexOf('/mylists') >= 0 && !this.isReorder;
    }


    pushDataToAnalyticsService() {
        this.analyticsService.push({
            data: {
                trackingType: 'link',
            },
            type: this.analyticsService.mapperTypes.customEvent.menuClick,
        });
    }
}

const coreHeaderNavComponentDefinition = {
    bindings: {
        classModifier: '@?',
        onInspirationSelected: '&?',
        onRecipesSelected: '&?',
    },
    controller: ['ShopperService', 'AnalyticsService', 'SettingsService', '$rootScope', '$location', CoreHeaderNavController],
    template: require('./core-header-nav.component.html').trim(),
};

module.exports = {
    CoreHeaderNavController,
    coreHeaderNavComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/header/core-header-nav.component.js